import { render } from "./QualityAnalysisBreakdown.vue?vue&type=template&id=17f27069&scoped=true"
import script from "./QualityAnalysisBreakdown.vue?vue&type=script&lang=js"
export * from "./QualityAnalysisBreakdown.vue?vue&type=script&lang=js"

import "./QualityAnalysisBreakdown.vue?vue&type=style&index=0&id=17f27069&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f27069"]])

export default __exports__